import React from 'react';
const FBVHead = ({year, portfolioDetail}) => {
  return(
    <th className="content-box">
      {year} <span style={{fontSize:'9px'}}>(In Millions)</span>
      <table>
        <tr>
          <td>0%</td>
          <td>{portfolioDetail.inflation_rate}%</td>
        </tr>
      </table>
    </th>
  )
}
export default FBVHead;
